<template>
  <div>
    <!-- 筛选 -->
    <div class="container" style="margin-bottom:10px;">
      <Row class="header-common-right-box">
        <Col span="3" class="header-common-col">
          关键字
        </Col>
        <Col span="9">
          <Input
            v-model="searchForm.keyword" placeholder="姓名/执业机构" style="width:100%"
            @on-enter="reloadTable"
          >
            <Icon slot="suffix" type="ios-search" @click="reloadTable" />
          </Input>
        </Col>
        <Col span="3" class="header-common-col">
          身份类型
        </Col>
        <Col span="9">
          <Select v-model="searchForm.teamType" placeholder="请选择任务类型" style="width:100%">
            <Option v-for="item in teamTypeArr" :key="item.value" :value="item.value">{{ item.nameZh }}</Option>
          </Select>
        </Col>
      </Row>
      <Row class="header-common-right-box">
        <Col span="3" class="header-common-col">
          所属区域
        </Col>
        <Col span="9">
          <City ref="transEvent" style="width:100%;" @listenCity="getCity" />
        </Col>
        <Col span="12" style="text-align:left;padding-left:25px;">
          <Button
            type="primary" size="small" style="margin-right:12px;"
            @click="reloadTable"
          >
            确定
          </Button>
          <Button size="small" @click="clearConditions">重置</Button>
        </Col>
      </Row>
    </div>
    <!-- 表格 -->
    <Row style="border:1px solid #dcdee2;border-bottom:0;">
      <Table
        :columns="columns" :data="data"
        :loading="tableLoading"
        @on-select-cancel="fnCancel"
        @on-select-all-cancel="fnCancelAll"
        @on-select="fnSelect"
        @on-select-all="fnSelectAll"
      />
    </Row>
    <Row style="margin-top:30px;text-align:center;">
      <Page
        :total="table.totalRecords" show-total

        size="small"
        :current="table.pageNum"
        :page-size-opts="config.modalPageSizeOpts"
        :page-size="config.modalPageSize"
        :prev-text="$t('PreviousPage')" :next-text="$t('NextPage')"
        show-sizer
        show-elevator
        @on-change="changePage" @on-page-size-change="changeSize"
      />
    </Row>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    defaultData: {
      type: Array,
      required: true
    },
    assignTeamArr: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: this.$t('Name'),
          key: 'team'
        },
        {
          title: '执业机构',
          key: 'company'
        },
        {
          title: '调查区域',
          key: 'provinceName',
          render: (h, params) => {
            return h('span', {
              class: 'textover',
              attrs: {
                title: params.row.province + (params.row.city || '') + (params.row.area || '')
              }
            }, params.row.province + (params.row.city || '') + (params.row.area || ''))
          }
        },
        {
          title: '身份类型',
          key: 'teamType'
        }
      ],
      data: [],
      tableLoading: false,
      table: {
        totalRecords: 1,
        pageNum: 1,
        pageSize: this.config.modalPageSize
      },
      searchForm: {
        keyword: '',
        teamType: '',
        province: '',
        city: '',
        area: ''
      },
      teamTypeArr: [],
      tempIdList: [],
      idList: [],
      tempData: [],
      selectedArr: [],
      tempDataArr: []
    }
  },
  watch: {

  },
  created() {},
  beforeMount() {
    this.getDictionary()
  },
  mounted() {
    this.tempData = JSON.parse(JSON.stringify(this.defaultData))
    this.idList = this.tempData
    this.selectedArr = JSON.parse(JSON.stringify(this.assignTeamArr))
    this.tempDataArr = this.selectedArr
    this.getData()
  },
  updated() {},
  methods: {
    // 获取数据
    getData() {
      const url = '/user/team/queryTeams'
      const ajaxData = {
        page: {
          current: this.table.pageNum,
          size: this.table.pageSize
        },
        condition: {}
      }
      Object.assign(ajaxData['condition'], this.searchForm)
      this.tableLoading = true
      this.$post(url, ajaxData).then(res => {
        this.tableLoading = false
        if (res.code == 0) {
          this.data = res.data.records
          this.table.totalRecords = res.data.total
          // 查看已经勾选项,默认勾选
          this.tempIdList = res.data.records
          this.selectOrNo(this.idList, res.data.records)
        }
      })
    },
    changePage(page) {
      this.table.pageNum = page
      this.getData()
    },
    changeSize(size) {
      this.table.pageSize = size
      this.getData()
    },
    // 重载table
    reloadTable() {
      this.table.pageNum = 1
      this.getData()
    },
    // 清除条件
    clearConditions() {
      this.searchForm.keyword = ''
      this.searchForm.teamType = ''
      this.searchForm.province = ''
      this.searchForm.city = ''
      this.searchForm.area = ''
      this.$refs.transEvent.clearSelect()
      this.reloadTable()
    },
    // 搜索条件省市区接口
    getCity(data) {
      let area
      if (data.length != 0) {
        if (data.length == 1) {
          this.searchForm.province = data[0].value
          this.searchForm.city = ''
          this.searchForm.area = ''
          area = data[0].label
        } else if (data.length == 2) {
          this.searchForm.province = data[0].value
          this.searchForm.city = data[1].value
          this.searchForm.area = ''
          area = data[0].label + data[1].label
        } else if (data.length == 3) {
          this.searchForm.province = data[0].value
          this.searchForm.city = data[1].value
          this.searchForm.area = data[2].value
          area = data[0].label + data[1].label + data[2].label
        }
      } else {
        this.searchForm.province = ''
        this.searchForm.city = ''
        this.searchForm.area = ''
        area = ''
      }
    },
    getAssignTeam() {
      this.tempData = this.idList
    },
    cancel() {
      this.idList = this.tempData
    },
    /* --------------------start---------------------*/
    // 获取批量操作勾选中的数据
    fnSelectAll(selection) {
      if (this.idList.length == 0) {
        for (var i = 0; i < selection.length; i++) {
          this.addItem(selection[i])
        }
      } else {
        for (var i = 0; i < selection.length; i++) {
          for (var j = 0; j < this.idList.length; j++) {
            if (this.idList[j] == selection[i].id) {
              break
            }
            if (this.idList[j] != selection[i].id) {
              if (j == this.idList.length - 1) {
                this.addItem(selection[i])
              }
            }
          }
        }
      }
    },
    fnSelect(selection, row) {
      this.addItem(row)
    },
    fnCancel(selection, row) {
      this.remove(this.idList, row.id)
    },
    fnCancelAll(selection) {
      if (selection.length == 0) {
        for (var i = 0; i < this.tempIdList.length; i++) {
          this.remove(this.idList, this.tempIdList[i].id)
        }
      }
    },
    // 添加特定的id
    addItem(item) {
      this.idList.push(item.id)
      this.selectedArr.push(item)
    },
    // 删除特定的id
    remove(arr, id) {
      const index = arr.indexOf(id)
      if (index > -1) {
        arr.splice(index, 1)
        this.selectedArr.splice(index, 1)
      }
    },
    // 每请求一页的时候判断是否被选中
    selectOrNo(arr1, arr2) {
      for (var i = 0; i < arr1.length; i++) {
        for (var j = 0; j < arr2.length; j++) {
          if (arr1[i] == arr2[j].id) {
            arr2[j]._checked = true
          }
        }
      }
    },
    /* --------------------end---------------------*/
    // 获取字典数据接口
    async getDictionary() {
      this.teamTypeArr = await this.common.getDictionaryItems('team_type')
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/common/assignTeam/assignTeam.vue